export default __webpack_public_path__ + "static/media/h-presenting.c7123efb.gif";